module.exports = __webpack_public_path__ + "static/media/Favourites_Purple@3x.ab1d3a81.png";